export enum RecoveryTokensTypeFilter {
    All = 'all',
    UserPage = 'user_pages',
    DeletedByUser = 'deleted_by_user',
}
